import { CommercialProductSubType } from '../../../../generated/api/commercialProductSubType';
import { EmptyOrError, getNotFoundError } from '../../../../components/EmptyOrError/index.js';
import { Loading } from '../../../../components/Loading/index.js';
import { ModelType } from '../../../../common/enums.js';
import { NettiLiteOffers } from '../../../../components/NettiLiteOffers/NettiLiteOffers.js';
import { OnlineModelCategory } from '../../../../generated/api/onlineModelCategory.js';
import { applyWizardEvent, searchAddress } from '../../../../selfservice/actions/index.js';
import { fetchAvailableFixedBroadbandOffers } from '../../../../common/fetch';
import { paths } from '../../../../common/constants/pathVariables.js';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import type { CommercialProduct } from '../../../../generated/api/commercialProduct';
import type { OnlineModel } from '../../../../generated/api/onlineModel.js';
import type { State } from '../../../../selfservice/common/store.js';

export const FixedBroadbandOffersPath = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { addressSearchResult } = useSelector((s: State) => ({
    addressSearchResult: s?.resources?.addressSearchResult,
  }));
  const { state } = useLocation();
  const [offerAvailabilityLoading, setOfferAvailabilityLoading] = useState<boolean>(true);
  const [offerAvailabilityResponse, setOfferAvailabilityResponse] = useState<OnlineModel[]>([]);
  const { search } = useLocation();

  const selectedAddressId = addressSearchResult?.match?.addressId;

  useEffect(() => {
    setOfferAvailabilityLoading(true);
    if (selectedAddressId) {
      fetchAvailableFixedBroadbandOffers(selectedAddressId, OnlineModelCategory.FIXED_BROADBAND).then(resp => {
        setOfferAvailabilityResponse(resp.models || []);
        setOfferAvailabilityLoading(false);
      });
    } else {
      navigate(paths.ANONYMOUS_FIXED_BROADBAND_ORDER + search);
    }
  }, [navigate, search, selectedAddressId]);

  const isMobileBroadband = (cp: CommercialProduct) =>
    cp.productSubType && cp.productSubType === CommercialProductSubType.MOBILE_BROADBAND;
  const elisaNetti = offerAvailabilityResponse.find(model => model.onlineModelCode === ModelType.ElisaNetti);

  useEffect(() => {
    if (
      offerAvailabilityResponse.length === 0 &&
      !offerAvailabilityLoading &&
      !!state?.searchAddress &&
      state?.postalCode
    ) {
      dispatch(searchAddress(state?.searchAddress, state?.postalCode));
    }
  }, [dispatch, state?.searchAddress, state?.postalCode, offerAvailabilityResponse.length, offerAvailabilityLoading]);

  useEffect(() => {
    dispatch(applyWizardEvent(1, 'FIXED_BROADBAND_ORDER'));
  }, [dispatch]);

  if (offerAvailabilityLoading) {
    return <Loading />;
  }

  if (!state?.previousUrl) {
    return (
      <EmptyOrError {...getNotFoundError()} onButtonClick={() => navigate(paths.ANONYMOUS_FIXED_BROADBAND_ORDER)} />
    );
  }

  if (!elisaNetti) {
    return null;
  }

  const fixedBroadbandOnlineModel = {
    ...elisaNetti,
    offers: elisaNetti.offers.filter(offer => !isMobileBroadband(offer.commercialProducts[0])),
  };
  const mobileBroadbandOnlineModel = {
    ...elisaNetti,
    offers: elisaNetti.offers.filter(offer => isMobileBroadband(offer.commercialProducts[0])),
  };

  if (!fixedBroadbandOnlineModel) {
    return null;
  }

  return (
    <NettiLiteOffers
      fixedBroadBandOnlineModel={fixedBroadbandOnlineModel}
      mobileBroadBandOnlineModel={mobileBroadbandOnlineModel}
      availabilityAddress={state?.searchAddress}
      postalCode={state?.postalCode}
    />
  );
};
